import { io } from 'socket.io-client';
import { environment } from 'config';

const {
  api: { uri },
} = environment;
const socketIo = (string) => io(`${uri.slice(0, uri.length - 3)}${string}`);

export { socketIo };
